import { render, staticRenderFns } from "./specialPage.vue?vue&type=template&id=5e2a4e9e&scoped=true&"
import script from "./specialPage.vue?vue&type=script&lang=js&"
export * from "./specialPage.vue?vue&type=script&lang=js&"
import style0 from "./specialPage.vue?vue&type=style&index=0&id=5e2a4e9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2a4e9e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
